import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../../../../../hooks/dialog/useDialogContext';
import { CREATION_METHOD } from '../../../../../../../../../../../../shared/interfaces/IFootprint';

interface PublishButtonProps {
  productId: number;
  footprintId: number;
  calculationId: number;
}

const PublishButton = ({
  footprintId,
  productId,
  calculationId,
}: PublishButtonProps): JSX.Element => {
  const { t } = useTranslation();

  const { openDialog } = useDialogContext();

  const onClick = () => {
    openDialog('publish-pcf-confirmation-dialog', {
      productId,
      pcfId: footprintId,
      calculationId,
      creationMethod: CREATION_METHOD.CALCULATION,
    });
  };

  return (
    <Button
      onClick={onClick}
      label={t('productDetailsPage.buttons.publish')}
      icon='pi pi-arrow-right'
      iconPos='right'
      className='w-full md:w-auto md:min-w-max'
    />
  );
};

export default PublishButton;
